import React, { useEffect, useState } from 'react'
import { v2_projects } from '../../../actions/v2/projectAndVessel';

const SearchBar = ({ onSearch, onReset }) => {
    const [filterData, setFilterData] = useState({
        project: { name: 'project', value: '', options: [] },
    });
    useEffect(() => {
        v2_projects().then((res) => {
            if (res.status) {
                setFilterData((prev) => ({
                    ...prev,
                    ['project']: { ...prev['project'], options: res.result }
                }));
            }
        })
    }, [])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilterData((prev) => ({
            ...prev,
            [name]: { ...prev[name], value }
        }));
    };
    const handleSearch = () => {
        const modelPayload = {
            project: filterData.project.value?.trim() || ''
        };
        const encodedPayload = btoa(JSON.stringify(modelPayload));

        if (onSearch) {
            onSearch(encodedPayload); // Send base64 string to parent
        }
    };


    const handleReset = () => {
        const resetData = {
            project: { name: 'project', value: '', options: [] },
        };
        setFilterData((prev) => ({
            ...prev,
            ['project']: { ...prev['project'], value:'' }
        }));
        if (onReset) {
            onReset(resetData);
        }
    };
    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <form className="row gy-12 gx-12 align-items-center">
                            <div className="col-sm-2">
                                <label className="visually-hidden" htmlFor="autoSizingInput">
                                    Project
                                </label>
                                Search Project
                            </div>
                            <div className="col-sm-6">
                                <label className="visually-hidden" htmlFor="autoSizingInputGroup">
                                    Project
                                </label>
                                <div className="input-group">
                                    <select
                                        className="form-control"
                                        id="autoSizingInputGroup"
                                        name={filterData.project.name}
                                        value={filterData.project.value}
                                        onChange={handleChange}
                                    >
                                        <option> Select Project</option>
                                        {filterData.project.options.map((item) => {
                                            return (
                                                <option value={item.ID}> {item.PROJECT_CODE} - {item.PROJECT_NAME}</option>

                                            )
                                        })}
                                    </select>
                                </div>
                            </div>
                            <div className="col-sm-4">
                                <button
                                    type="button"
                                    className="btn btn-success waves-effect btn-label waves-light"
                                    style={{
                                        backgroundImage: "linear-gradient(90deg, #0ddcef, #319bfc)"
                                    }}
                                    onClick={() => { handleSearch() }}
                                >
                                    <i className="bx bx-check-double label-icon" /> Search
                                </button>
                                &nbsp;{" "}
                                <button type="button" className="btn btn-outline-danger"
                                    onClick={() => { handleReset() }}

                                >
                                    Reset
                                </button>
                            </div>
                        </form>
                    </div>
                    {/* end card body */}
                </div>
                {/* end card */}
            </div>
            {/* end col */}
        </div>

    )
}

export default SearchBar